import { styled } from '@mui/material'
import Card from '@mui/material/Card'

const DefaultCorner = styled('div')({
   width: 35,
   height: 35,
   position: 'absolute',
   transition: '400ms',
})

export const EditCorner = styled(DefaultCorner)(({ theme }) => ({
   paddingTop: 8,
   paddingLeft: 8,
   top: 155,
   left: 155,
   cursor: 'pointer',
   borderLeft: '0px solid grey',
   borderTop: '0px solid grey',
   borderTopLeftRadius: '75%',
   boxShadow: '0 0 0.5em grey',
   '&:hover': {
      boxShadow: `0 0 1em ${theme.palette.primary.main}`,
      color: `${theme.palette.primary.main}`,
   },
}))

export const StyledCard = styled(Card)(({ theme }) => ({
   display: 'flex',
   justifyContent: 'center',
   alignItems: 'center',
   position: 'relative',
   width: 160,
   height: 160,
   borderRadius: 5,
   backgroundColor: 'rgba(255,255,255,0.7)',
   '&:hover': {
      boxShadow: `0 0 1.5em ${theme.palette.primary.main}`,
      '& > div': {
         '&:nth-of-type(2)': {
            left: 130,
            top: 130,
         },
      },
   },
}))

export const RejectedCorner = styled(DefaultCorner)({
   top: 0,
   left: 0,
   borderRight: '0px solid red',
   borderBottom: '0px solid red',
   borderBottomRightRadius: '75%',
   boxShadow: `0 0 0.5em red`,
   '&:hover': {
      boxShadow: `0 0 1.2em red`,
   },
})

export const StyledImg = styled('img')({
   height: 25,
})
